import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { CreateCommentDto } from '../types'

export const useCommentCrud = () => {
  const { authenticatedPost } = useAuth()

  const create = async (discussionId: number, dto: CreateCommentDto) => {
    const { data } = await authenticatedPost<Comment>(
      `/api/v2/discussions/${discussionId}/comments`,
      { body: JSON.stringify(dto.body) }
    )
    return data
  }

  return { create }
}
